
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as pes03k8Txei6XbCaEBQbDG7I56nCiKZznLqD_45YBuDuMliYMeta } from "/app/apps/onboarding/pages/pes.vue?macro=true";
import { default as ciipxdJcc4hRBgdMdyoTZEaBpqioZ_455GHS66Rey_45z9MKOv0Meta } from "/app/apps/onboarding/pages/ciip.vue?macro=true";
import { default as homeU9fh_451zQywxe9IYnOGUWk_45R5_4557V61e8i1la1HZnmQIMeta } from "/app/apps/onboarding/pages/home.vue?macro=true";
import { default as oktaXpE8ZyHZ_45u5eZOS6KSL6sl2yJcmESI692ZtRIKzpbVMMeta } from "/app/apps/onboarding/pages/okta.vue?macro=true";
import { default as unoiXkHo702DyYsStIT3VpJZmB2uZ_45u4WeM8aG_45m4350fycMeta } from "/app/apps/onboarding/pages/unoi.vue?macro=true";
import { default as termsOcoOwGmRlQ5Ewczm7S_45hZm3EQx4QJfZmxkZf2uQfEz4Meta } from "/app/apps/onboarding/pages/terms.vue?macro=true";
import { default as bayardOmMAHCqCLidhfOLkw3gKR_DOu3iAoYGEWSVYe_dublkMeta } from "/app/apps/onboarding/pages/bayard.vue?macro=true";
import { default as edulog8SMGdSG49F4nxXECbgetOBT4r9h3SHG_45GhUyZlGebJAMeta } from "/app/apps/onboarding/pages/edulog.vue?macro=true";
import { default as privacyLWDr9_45yAVAhUdM5r_SckirX6cST0hptshlKPR_45gAt7sMeta } from "/app/apps/onboarding/pages/privacy.vue?macro=true";
import { default as lti_45error4szfMERjQYkwIBsFPghxtceJcxczK9g7Bythy6tc5dgMeta } from "/app/apps/onboarding/pages/lti-error.vue?macro=true";
import { default as error_45cardNzSn0ryC7g4Em9KQjsenFWTGbdpmkoAQAS5ANcqzJJkMeta } from "/app/apps/onboarding/pages/error-card.vue?macro=true";
import { default as regoptionsvvqclpn2WV5f_45CJtE9_45MvmraaOAfJNprKNR60EmPaVgMeta } from "/app/apps/onboarding/pages/regoptions.vue?macro=true";
import { default as authenticateXPImKY5yJ09v_cpkrfw5RlGbw1kgyoGkRiEvrgVx97YMeta } from "/app/apps/onboarding/pages/authenticate.vue?macro=true";
import { default as accessibility9y6eURwnk9IdojXpWumrDv40pjkUJaPNwxmLiedsgLUMeta } from "/app/apps/onboarding/pages/accessibility.vue?macro=true";
import { default as desktop_45login107yEJ8noQWIbpOv7icbEW8UfL3SNbLPxAA2CHuYK_45cMeta } from "/app/apps/onboarding/pages/desktop-login.vue?macro=true";
import { default as lti_45onboardingh5qti_45OPQ7aLBlRF_45G6aqQtyIVE64BHR2AfyALzbeM0Meta } from "/app/apps/onboarding/pages/lti-onboarding.vue?macro=true";
import { default as _91type_93_45passwordKXEZ0SjDLWydY7J5zK3Ye9mNTxIMje_45t2Csj5QZKMlIMeta } from "/app/apps/onboarding/pages/[type]-password.vue?macro=true";
import { default as register_45_91user_93oQbXGh2rKhMBMS0YGhy8OszrcPBRiRRu5t3ZdVNP0K8Meta } from "/app/apps/onboarding/pages/register-[user].vue?macro=true";
import { default as login_91_91segment_93_938CUqPOAn9Xa7YE7QiAUoPLwkCVk6i9lGf79Ol9woNjgMeta } from "/app/apps/onboarding/pages/login[[segment]].vue?macro=true";
import { default as parental_45consentc9e4oAh9K_45wrKghiGjq_btn3OXJvhvZSdt54Z6FuZwMMeta } from "/app/apps/onboarding/pages/parental-consent.vue?macro=true";
import { default as generic_45lti_45erroryFPWjjuNS6_45kZiuG_45R4t6ammCMrk1YWhfy_WNShaZ5oMeta } from "/app/apps/onboarding/pages/generic-lti-error.vue?macro=true";
import { default as child_45registrationw9YYK0bpd_aV12FtOhP8SQ2FZGfiVecD8lIdaws9bC8Meta } from "/app/apps/onboarding/pages/child-registration.vue?macro=true";
import { default as learner_45age_45_91type_937UY1oKff2iPmW612E0VrHZucgqyGnJVCcNp3maKTAW0Meta } from "/app/apps/onboarding/pages/learner-age-[type].vue?macro=true";
import { default as institution_45requestFG4TipoOADImYuIRPK2ULen_45YcJfdR_GvXeH1BgIHH4Meta } from "/app/apps/onboarding/pages/institution-request.vue?macro=true";
import { default as verification_45link_45expiredWzGxHfM7DSnPx3AsQltiJNGT_45Q_4505CLVHmCfCfXpK64Meta } from "/app/apps/onboarding/pages/verification-link-expired.vue?macro=true";
import { default as _91umbrella_code_93tTM5YaDC5ig7YoB_jlRc3uhAeXXIpzgk1Qq0_s4uTV4Meta } from "/app/apps/onboarding/pages/freetrial/info/[umbrella_code].vue?macro=true";
import { default as _91errorType_93Gr9qJ7f02_y_oJ2wVJ_hN0T2IxNMI3YfLzXyrcQTl_EMeta } from "/app/apps/onboarding/pages/lti-onboarding-error/[errorType].vue?macro=true";
import { default as _91id_93tEAHJGP8vkPv_45nGE9xZlYQ_455vW_ZqVfoUpYE4LVv6wYMeta } from "/app/apps/onboarding/pages/[orgId]/[context]/[classId]/invitation/[id].vue?macro=true";
import { default as _91ltik_93A3HgMjdGCRdKS4gNBekW_45dOPGZVm_z2GHvEIimce2TAMeta } from "/app/apps/onboarding/pages/lti-teacher-dashboard/[spaceId]/class/[classId]/ltik/[ltik].vue?macro=true";
import { default as _91ltik_93ywVKcsuse2rPiGrZxQqRJjjwaDBuZfplvsqJ0C1pRfQMeta } from "/app/apps/onboarding/pages/lti-product-selection/[spaceId]/class/[classId]/resource/[resource]/ltik/[ltik].vue?macro=true";
import { default as _91ltik_93DesQGigJB8Kgnd_QsSZqXkwnaghUOZtyBrsr4hHrltwMeta } from "/app/apps/onboarding/pages/lti-progress-selection/[spaceId]/class/[classId]/resource/[resource]/ltik/[ltik].vue?macro=true";
import { default as _91ltik_93woPUex_45oFgZBu21AJsOd3VuVAYZVgL8CZNLY2heFYmcMeta } from "/app/apps/onboarding/pages/lti-component-selection/[spaceId]/class/[classId]/bundle/[bundleCode]/resource/[resource]/ltik/[ltik].vue?macro=true";
import { default as _91ltik_93gUmJ9E1GgRVFxYzMfRGL1o_45sCpXkvEzsVxMj8VrPpr8Meta } from "/app/apps/onboarding/pages/lti-activate-course-material/[spaceId]/class/[classId]/product/[productCode]/resource/[resource]/ltik/[ltik].vue?macro=true";
import { default as homehHT4_A7gV_45zettnc4h_sijEcnrlcz_83K2YgfP2JOUwMeta } from "~/pages/home.vue?macro=true";
export default [
  {
    name: "pes",
    path: "/pes",
    meta: pes03k8Txei6XbCaEBQbDG7I56nCiKZznLqD_45YBuDuMliYMeta || {},
    component: () => import("/app/apps/onboarding/pages/pes.vue")
  },
  {
    name: "ciip",
    path: "/ciip",
    meta: { ...(ciipxdJcc4hRBgdMdyoTZEaBpqioZ_455GHS66Rey_45z9MKOv0Meta || {}), ...{"middleware":["page-redirection"]} },
    component: () => import("/app/apps/onboarding/pages/ciip.vue")
  },
  {
    name: "home",
    path: "/home",
    meta: {"middleware":["page-redirection"]},
    component: () => import("/app/apps/onboarding/pages/home.vue")
  },
  {
    name: "okta",
    path: "/okta",
    meta: { ...(oktaXpE8ZyHZ_45u5eZOS6KSL6sl2yJcmESI692ZtRIKzpbVMMeta || {}), ...{"middleware":["page-redirection"]} },
    component: () => import("/app/apps/onboarding/pages/okta.vue")
  },
  {
    name: "unoi",
    path: "/unoi",
    meta: unoiXkHo702DyYsStIT3VpJZmB2uZ_45u4WeM8aG_45m4350fycMeta || {},
    component: () => import("/app/apps/onboarding/pages/unoi.vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: { ...(termsOcoOwGmRlQ5Ewczm7S_45hZm3EQx4QJfZmxkZf2uQfEz4Meta || {}), ...{"middleware":["common-loader"]} },
    component: () => import("/app/apps/onboarding/pages/terms.vue")
  },
  {
    name: "bayard",
    path: "/bayard",
    meta: { ...(bayardOmMAHCqCLidhfOLkw3gKR_DOu3iAoYGEWSVYe_dublkMeta || {}), ...{"middleware":["page-redirection"]} },
    component: () => import("/app/apps/onboarding/pages/bayard.vue")
  },
  {
    name: "edulog",
    path: "/edulog",
    meta: { ...(edulog8SMGdSG49F4nxXECbgetOBT4r9h3SHG_45GhUyZlGebJAMeta || {}), ...{"middleware":["page-redirection"]} },
    component: () => import("/app/apps/onboarding/pages/edulog.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: { ...(privacyLWDr9_45yAVAhUdM5r_SckirX6cST0hptshlKPR_45gAt7sMeta || {}), ...{"middleware":["common-loader"]} },
    component: () => import("/app/apps/onboarding/pages/privacy.vue")
  },
  {
    name: "lti-error",
    path: "/lti-error",
    meta: { ...(lti_45error4szfMERjQYkwIBsFPghxtceJcxczK9g7Bythy6tc5dgMeta || {}), ...{"middleware":["common-loader"]} },
    component: () => import("/app/apps/onboarding/pages/lti-error.vue")
  },
  {
    name: "error-card",
    path: "/error-card",
    component: () => import("/app/apps/onboarding/pages/error-card.vue")
  },
  {
    name: "regoptions",
    path: "/regoptions",
    meta: { ...(regoptionsvvqclpn2WV5f_45CJtE9_45MvmraaOAfJNprKNR60EmPaVgMeta || {}), ...{"middleware":["page-redirection","common-loader"]} },
    component: () => import("/app/apps/onboarding/pages/regoptions.vue")
  },
  {
    name: "authenticate",
    path: "/authenticate",
    meta: authenticateXPImKY5yJ09v_cpkrfw5RlGbw1kgyoGkRiEvrgVx97YMeta || {},
    component: () => import("/app/apps/onboarding/pages/authenticate.vue")
  },
  {
    name: "accessibility",
    path: "/accessibility",
    meta: { ...(accessibility9y6eURwnk9IdojXpWumrDv40pjkUJaPNwxmLiedsgLUMeta || {}), ...{"middleware":["common-loader"]} },
    component: () => import("/app/apps/onboarding/pages/accessibility.vue")
  },
  {
    name: "desktop-login",
    path: "/desktop-login",
    component: () => import("/app/apps/onboarding/pages/desktop-login.vue")
  },
  {
    name: "lti-onboarding",
    path: "/lti-onboarding",
    meta: { ...(lti_45onboardingh5qti_45OPQ7aLBlRF_45G6aqQtyIVE64BHR2AfyALzbeM0Meta || {}), ...{"middleware":["lti-onboarding"]} },
    component: () => import("/app/apps/onboarding/pages/lti-onboarding.vue")
  },
  {
    name: "type-password",
    path: "/:type()-password",
    meta: { ...(_91type_93_45passwordKXEZ0SjDLWydY7J5zK3Ye9mNTxIMje_45t2Csj5QZKMlIMeta || {}), ...{"middleware":["page-redirection"]} },
    component: () => import("/app/apps/onboarding/pages/[type]-password.vue")
  },
  {
    name: "register-user",
    path: "/register-:user()",
    meta: { ...(register_45_91user_93oQbXGh2rKhMBMS0YGhy8OszrcPBRiRRu5t3ZdVNP0K8Meta || {}), ...{"middleware":["page-redirection"]} },
    component: () => import("/app/apps/onboarding/pages/register-[user].vue")
  },
  {
    name: "loginsegment",
    path: "/login:segment?",
    meta: { ...(login_91_91segment_93_938CUqPOAn9Xa7YE7QiAUoPLwkCVk6i9lGf79Ol9woNjgMeta || {}), ...{"middleware":["common-loader","page-redirection"]} },
    component: () => import("/app/apps/onboarding/pages/login[[segment]].vue")
  },
  {
    name: "parental-consent",
    path: "/parental-consent",
    meta: { ...(parental_45consentc9e4oAh9K_45wrKghiGjq_btn3OXJvhvZSdt54Z6FuZwMMeta || {}), ...{"middleware":"parent-login"} },
    component: () => import("/app/apps/onboarding/pages/parental-consent.vue")
  },
  {
    name: "generic-lti-error",
    path: "/generic-lti-error",
    meta: { ...(generic_45lti_45erroryFPWjjuNS6_45kZiuG_45R4t6ammCMrk1YWhfy_WNShaZ5oMeta || {}), ...{"middleware":["common-loader"]} },
    component: () => import("/app/apps/onboarding/pages/generic-lti-error.vue")
  },
  {
    name: "child-registration",
    path: "/child-registration",
    meta: {"middleware":["common-loader"]},
    component: () => import("/app/apps/onboarding/pages/child-registration.vue")
  },
  {
    name: "learner-age-type",
    path: "/learner-age-:type()",
    meta: { ...(learner_45age_45_91type_937UY1oKff2iPmW612E0VrHZucgqyGnJVCcNp3maKTAW0Meta || {}), ...{"middleware":["page-redirection"]} },
    component: () => import("/app/apps/onboarding/pages/learner-age-[type].vue")
  },
  {
    name: "institution-request",
    path: "/institution-request",
    meta: { ...(institution_45requestFG4TipoOADImYuIRPK2ULen_45YcJfdR_GvXeH1BgIHH4Meta || {}), ...{"middleware":["common-loader"]} },
    component: () => import("/app/apps/onboarding/pages/institution-request.vue")
  },
  {
    name: "verification-link-expired",
    path: "/verification-link-expired",
    meta: { ...(verification_45link_45expiredWzGxHfM7DSnPx3AsQltiJNGT_45Q_4505CLVHmCfCfXpK64Meta || {}), ...{"middleware":["common-loader"]} },
    component: () => import("/app/apps/onboarding/pages/verification-link-expired.vue")
  },
  {
    name: "freetrial-info-umbrella_code",
    path: "/freetrial/info/:umbrella_code()",
    meta: { ...(_91umbrella_code_93tTM5YaDC5ig7YoB_jlRc3uhAeXXIpzgk1Qq0_s4uTV4Meta || {}), ...{"middleware":["common-loader"]} },
    component: () => import("/app/apps/onboarding/pages/freetrial/info/[umbrella_code].vue")
  },
  {
    name: "lti-onboarding-error-errorType",
    path: "/lti-onboarding-error/:errorType()",
    meta: { ...(_91errorType_93Gr9qJ7f02_y_oJ2wVJ_hN0T2IxNMI3YfLzXyrcQTl_EMeta || {}), ...{"middleware":["common-loader"]} },
    component: () => import("/app/apps/onboarding/pages/lti-onboarding-error/[errorType].vue")
  },
  {
    name: "orgId-context-classId-invitation-id",
    path: "/:orgId()/:context()/:classId()/invitation/:id()",
    meta: {"middleware":["common-loader"]},
    component: () => import("/app/apps/onboarding/pages/[orgId]/[context]/[classId]/invitation/[id].vue")
  },
  {
    name: "lti-teacher-dashboard-spaceId-class-classId-ltik-ltik",
    path: "/lti-teacher-dashboard/:spaceId()/class/:classId()/ltik/:ltik()",
    meta: { ...(_91ltik_93A3HgMjdGCRdKS4gNBekW_45dOPGZVm_z2GHvEIimce2TAMeta || {}), ...{"middleware":["common-loader","lti-onboarding"]} },
    component: () => import("/app/apps/onboarding/pages/lti-teacher-dashboard/[spaceId]/class/[classId]/ltik/[ltik].vue")
  },
  {
    name: "lti-product-selection-spaceId-class-classId-resource-resource-ltik-ltik",
    path: "/lti-product-selection/:spaceId()/class/:classId()/resource/:resource()/ltik/:ltik()",
    meta: { ...(_91ltik_93ywVKcsuse2rPiGrZxQqRJjjwaDBuZfplvsqJ0C1pRfQMeta || {}), ...{"middleware":["lti-onboarding"]} },
    component: () => import("/app/apps/onboarding/pages/lti-product-selection/[spaceId]/class/[classId]/resource/[resource]/ltik/[ltik].vue")
  },
  {
    name: "lti-progress-selection-spaceId-class-classId-resource-resource-ltik-ltik",
    path: "/lti-progress-selection/:spaceId()/class/:classId()/resource/:resource()/ltik/:ltik()",
    meta: { ...(_91ltik_93DesQGigJB8Kgnd_QsSZqXkwnaghUOZtyBrsr4hHrltwMeta || {}), ...{"middleware":["common-loader","lti-onboarding"]} },
    component: () => import("/app/apps/onboarding/pages/lti-progress-selection/[spaceId]/class/[classId]/resource/[resource]/ltik/[ltik].vue")
  },
  {
    name: "lti-component-selection-spaceId-class-classId-bundle-bundleCode-resource-resource-ltik-ltik",
    path: "/lti-component-selection/:spaceId()/class/:classId()/bundle/:bundleCode()/resource/:resource()/ltik/:ltik()",
    meta: { ...(_91ltik_93woPUex_45oFgZBu21AJsOd3VuVAYZVgL8CZNLY2heFYmcMeta || {}), ...{"middleware":["common-loader"]} },
    component: () => import("/app/apps/onboarding/pages/lti-component-selection/[spaceId]/class/[classId]/bundle/[bundleCode]/resource/[resource]/ltik/[ltik].vue")
  },
  {
    name: "lti-activate-course-material-spaceId-class-classId-product-productCode-resource-resource-ltik-ltik",
    path: "/lti-activate-course-material/:spaceId()/class/:classId()/product/:productCode()/resource/:resource()/ltik/:ltik()",
    meta: { ...(_91ltik_93gUmJ9E1GgRVFxYzMfRGL1o_45sCpXkvEzsVxMj8VrPpr8Meta || {}), ...{"middleware":["common-loader","lti-onboarding"]} },
    component: () => import("/app/apps/onboarding/pages/lti-activate-course-material/[spaceId]/class/[classId]/product/[productCode]/resource/[resource]/ltik/[ltik].vue")
  },
  {
    name: "index",
    path: "/",
    meta: {"middleware":["page-redirection"]},
    component: () => import("~/pages/home.vue")
  }
]